<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import { defaultGapSize } from './sizes.js';

    /**
     * @typedef {Object} Props
     * @property {Number} [gapSize]
     * @property {Number} [gapOffset]
     * @property {Number} [areaScrollHeight]
     * @property {Number} [areaScrollTop]
     * @property {Function} onTopAreaClick
     * @property {Function} onBottomAreaClick
     */
    /** @type {Props} */
    let {
        gapSize = defaultGapSize,
        gapOffset = 0,
        areaScrollHeight = 0,
        areaScrollTop = 0,
        onTopAreaClick,
        onBottomAreaClick
    } = $props();
</script>

<style>
    .item-content-overlay {
        position: absolute;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100%;
        pointer-events: all;
    }
</style>

<div
    class="item-content-overlay not-printable"
    style={`height: ${areaScrollTop + gapOffset}px`}
    aria-hidden={true}
    onclick={evt => {
        onTopAreaClick?.({
            pageY: evt.pageY
        });
    }}>
</div>
<div
    class="item-content-overlay not-printable"
    style={`
        height: ${areaScrollHeight - areaScrollTop - gapOffset - gapSize}px;
        transform: translateY(${gapOffset + gapSize + areaScrollTop}px);
    `}
    aria-hidden={true}
    onclick={evt => {
        onBottomAreaClick?.({
            pageY: evt.pageY
        });
    }}>
</div>
